export default __webpack_public_path__ + "static/avatar-b88a8bc85a2413cc56a96b2ac922b118.mp4";